import React from 'react';
import Section from './Section/Section';

function Tv() {
    return (
        <div className="Tv">
            <Section
                searchText="tv-animation"
            />
        </div>
    )
}

export default Tv